import { render, staticRenderFns } from "./DashInventory.vue?vue&type=template&id=42bf8df9&scoped=true&"
import script from "./DashInventory.vue?vue&type=script&lang=js&"
export * from "./DashInventory.vue?vue&type=script&lang=js&"
import style0 from "./DashInventory.vue?vue&type=style&index=0&id=42bf8df9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf8df9",
  null
  
)

export default component.exports